import apolloClient from '../apolloClient';
import { GET_CUSTOMER_PAYMENT_METHODS } from './queries/paymentMethods';
import { ADD_CUSTOMER_PAYMENT_METHOD, ASSIGN_PAYMENT_METHOD_TO_CAMPAIGN } from './mutations/paymentMethods';

/**
 * Fetch customer payment methods (simple list without campaign context)
 * To determine which payment method is selected for a specific campaign,
 * query the campaign's campaignPaymentMethods separately
 */
export const fetchCustomerPaymentMethodsGraphQL = async () => {
  try {
    const { data } = await apolloClient.query({
      query: GET_CUSTOMER_PAYMENT_METHODS,
      fetchPolicy: 'network-only'
    });

    return data.customerPaymentMethodsForCustomer || [];
  } catch (error) {
    console.error('Error fetching customer payment methods:', error);
    throw error;
  }
};

/**
 * Add customer payment method
 */
export const addCustomerPaymentMethodGraphQL = async (input) => {
  try {
    const { data } = await apolloClient.mutate({
      mutation: ADD_CUSTOMER_PAYMENT_METHOD,
      variables: { input }
    });

    return data.addPaymentMethodByCustomer;
  } catch (error) {
    console.error('Error adding customer payment method:', error);
    throw error;
  }
};

/**
 * Assign payment method to campaign
 */
export const assignPaymentMethodToCampaignGraphQL = async (input) => {
  try {
    const { data } = await apolloClient.mutate({
      mutation: ASSIGN_PAYMENT_METHOD_TO_CAMPAIGN,
      variables: { 
        input: {
          campaignId: parseInt(input.campaignId, 10),
          customerPaymentMethodId: parseInt(input.customerPaymentMethodId, 10)
        }
      }
    });

    return data.assignPaymentMethodToCampaign;
  } catch (error) {
    console.error('Error assigning payment method to campaign:', error);
    throw error;
  }
};

